var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal", class: _vm.isOpenProp ? "modal--open" : "" },
    [
      _c("div", { staticClass: "modal__cover" }),
      _vm._v(" "),
      _c("div", { staticClass: "modal__window" }, [
        _c(
          "button",
          { staticClass: "modal__close", on: { click: _vm.close } },
          [_vm._v("×")]
        ),
        _vm._v(" "),
        _c("div", { domProps: { innerHTML: _vm._s(_vm.copyProp) } }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "modal__action button button--primary",
            on: { click: _vm.close }
          },
          [_vm._v("OK")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }